import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

const SmartPagination = ({ total_pages, current_page, onPageChange }) => {
  if (total_pages <= 1) return null;

  const goToPage = (page) => {
    if (page >= 1 && page <= total_pages && page !== current_page) {
      onPageChange(page);
    }
  };

  const getPageNumbers = () => {
    const pages = new Set();

    pages.add(1);
    pages.add(total_pages);
    pages.add(current_page);

    if (current_page > 1) pages.add(current_page - 1);
    if (current_page < total_pages) pages.add(current_page + 1);

    return [...pages]
      .sort((a, b) => a - b)
      .reduce((acc, page, index, arr) => {
        if (index > 0 && page - arr[index - 1] > 1) {
          acc.push("ellipsis");
        }
        acc.push(page);
        return acc;
      }, []);
  };

  const renderPageItem = (item, index) => {
    if (item === "ellipsis") {
      return (
        <li key={index} className="page-item">
          <span className="page-link bg-transparent border-0">...</span>
        </li>
      );
    }

    const is_live = item === current_page;
    return (
      <li key={index} className="page-item">
        <button
          className={`page-link fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-40-px w-40-px ${is_live
            ? "bg-primary-600 text-white"
            : "bg-primary-50 text-secondary-light"
            }`}
          onClick={() => goToPage(item)}
        >
          {item}
        </button>
      </li>
    );
  };

  return (
    <div className="">
      {/* Top Pagination */}
      <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
        {/* First & Prev */}
        <li className="page-item">
          <button
            className="page-link bg-primary-50 text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-40-px w-40-px"
            onClick={() => goToPage(1)}
            disabled={current_page === 1}
          >
            <Icon icon="ep:d-arrow-left" className="text-xl" />
          </button>
        </li>
        <li className="page-item">
          <button
            className="page-link bg-primary-50 text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-40-px w-40-px"
            onClick={() => goToPage(current_page - 1)}
            disabled={current_page === 1}
          >
            <Icon icon="iconamoon:arrow-left-2-light" className="text-xxl" />
          </button>
        </li>

        {/* Page Numbers */}
        {getPageNumbers().map(renderPageItem)}

        {/* Next & Last */}
        <li className="page-item">
          <button
            className="page-link bg-primary-50 text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-40-px w-40-px"
            onClick={() => goToPage(current_page + 1)}
            disabled={current_page === total_pages}
          >
            <Icon icon="iconamoon:arrow-right-2-light" className="text-xxl" />
          </button>
        </li>
        <li className="page-item">
          <button
            className="page-link bg-primary-50 text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-40-px w-40-px"
            onClick={() => goToPage(total_pages)}
            disabled={current_page === total_pages}
          >
            <Icon icon="ep:d-arrow-right" className="text-xl" />
          </button>
        </li>
      </ul>
    </div>
  );
};

SmartPagination.propTypes = {
  total_pages: PropTypes.number.isRequired,
  current_page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default SmartPagination;
